"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Teller_1 = require("../../../../DriveScout/Billing/Teller");
var time_1 = require("../../../common/helpers/time");
var AdminOrdersController = /** @class */ (function () {
    function AdminOrdersController(OrdersModel, FlashService, PoliciesModel, $q, UserService, UsersModel) {
        var _this = this;
        this.loading = true;
        this.submitting = false;
        this.currentPage = 0;
        this.OrdersModel = OrdersModel;
        this.FlashService = FlashService;
        this.PoliciesModel = PoliciesModel;
        this.$q = $q;
        this.UsersModel = UsersModel;
        this.orders = [];
        this.stats = {
            gross_sales: 0,
            number_of_orders_placed: 0,
            number_of_products_purchased: 0,
            most_popular_product: null,
            coupons: {
                number_of_coupons_used: 0,
                number_of_redemptions: 0,
            },
        };
        this.busy = false;
        this.page_by = 20;
        this.currentUser = UserService.getCurrentUser();
        this.setStartDate = this.setStartDate.bind(this);
        this.setEndDate = this.setEndDate.bind(this);
        this.statsParams = {
            start_date: new Date(new Date().setDate(new Date().getDate() - 7)),
            end_date: new Date(),
            page_by: 20,
        };
        OrdersModel.salesReports({
            start_date: new Date(this.statsParams.start_date).toLocaleDateString(),
            end_date: new Date(this.statsParams.end_date).toLocaleDateString(),
        }).then(function (response) {
            _this.stats = response.stats;
        });
        OrdersModel.get({
            page_by: this.page_by,
            start_date: new Date(this.statsParams.start_date).toLocaleDateString(),
            end_date: new Date(this.statsParams.end_date).toLocaleDateString(),
        }).then(function (response) {
            _this.orders = response.orders.data.map(function (order) {
                return __assign(__assign({}, order), { created_at: (0, time_1.formatDateTime)((0, time_1.dateTimeStringToDate)(order.created_at), "MM/DD/YYYY h:mm A") });
            });
            _this.loading = false;
            _this.totalItems = response.orders.total;
        });
        this.inDollars = Teller_1.inDollars.bind(this);
    }
    AdminOrdersController.prototype.setStartDate = function (date) {
        if (date.selected[0]) {
            this.statsParams.start_date = date.selected[0];
        }
    };
    AdminOrdersController.prototype.setEndDate = function (date) {
        if (date.selected[0]) {
            this.statsParams.end_date = date.selected[0];
        }
    };
    AdminOrdersController.prototype.applyPreset = function (preset) {
        var daysAgo = new Date();
        daysAgo.setDate(daysAgo.getDate() - 7);
        if (preset === "7_DAYS") {
            daysAgo = new Date();
            daysAgo.setDate(daysAgo.getDate() - 7);
        }
        if (preset === "30_DAYS") {
            daysAgo = new Date();
            daysAgo.setDate(daysAgo.getDate() - 30);
        }
        if (preset === "90_DAYS") {
            daysAgo = new Date();
            daysAgo.setDate(daysAgo.getDate() - 90);
        }
        this.statsParams.start_date = new Date(daysAgo.getFullYear(), daysAgo.getMonth(), daysAgo.getDate(), 0, 0, 0);
        this.statsParams.end_date = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 0);
        this.submit();
    };
    AdminOrdersController.prototype.submit = function () {
        var _this = this;
        this.busy = true;
        var params = {
            page: this.currentPage,
            page_by: this.statsParams.page_by,
            start_date: (0, time_1.toYMD)(new Date(this.statsParams.start_date.getFullYear(), this.statsParams.start_date.getMonth(), this.statsParams.start_date.getDate(), 0, 0, 0)),
            end_date: (0, time_1.toYMD)(new Date(this.statsParams.end_date.getFullYear(), this.statsParams.end_date.getMonth(), this.statsParams.end_date.getDate(), 23, 59, 0)),
        };
        if (this.statsParams.status) {
            params.status = this.statsParams.status;
        }
        if (this.statsParams.source) {
            params.source = this.statsParams.source;
        }
        var salesParams = {
            start_date: (0, time_1.toYMD)(new Date(this.statsParams.start_date.getFullYear(), this.statsParams.start_date.getMonth(), this.statsParams.start_date.getDate(), 0, 0, 0)),
            end_date: (0, time_1.toYMD)(new Date(this.statsParams.end_date.getFullYear(), this.statsParams.end_date.getMonth(), this.statsParams.end_date.getDate(), 23, 59, 0)),
        };
        if (this.statsParams.status) {
            salesParams.status = this.statsParams.status;
        }
        if (this.statsParams.source) {
            salesParams.source = this.statsParams.source;
        }
        this.OrdersModel.salesReports(salesParams).then(function (response) {
            _this.stats = response.stats;
        });
        this.OrdersModel.get(params)
            .then(function (response) {
            _this.orders = response.orders.data.map(function (order) {
                order.created_at = (0, time_1.formatDateTime)((0, time_1.dateTimeStringToDate)(order.created_at), "MM/DD/YYYY h:mm A");
                return order;
            });
            _this.page_by = response.orders.per_page;
            _this.submitting = false;
            _this.busy = false;
            _this.totalItems = response.orders.total;
        })
            .catch(function (Error) {
            _this.submitting = false;
            _this.busy = false;
        });
    };
    AdminOrdersController.prototype.patchOrder = function (updatedOrder) {
        var orders = this.orders.map(function (order) {
            if (order.id === updatedOrder.id) {
                return updatedOrder;
            }
            return order;
        });
        this.orders = orders;
    };
    AdminOrdersController.prototype.pageChanged = function () {
        var _this = this;
        this.submitting = true;
        var params = {
            page: this.currentPage,
            page_by: this.statsParams.page_by,
            start_date: (0, time_1.toYMD)(new Date(this.statsParams.start_date.getFullYear(), this.statsParams.start_date.getMonth(), this.statsParams.start_date.getDate(), 0, 0, 0)),
            end_date: (0, time_1.toYMD)(new Date(this.statsParams.end_date.getFullYear(), this.statsParams.end_date.getMonth(), this.statsParams.end_date.getDate(), 23, 59, 0)),
        };
        if (this.statsParams.status) {
            params.status = this.statsParams.status;
        }
        if (this.statsParams.source) {
            params.source = this.statsParams.source;
        }
        this.OrdersModel.get(params).then(function (response) {
            _this.orders = response.orders.data.map(function (order) {
                return __assign(__assign({}, order), { created_at: (0, time_1.formatDateTime)((0, time_1.dateTimeStringToDate)(order.created_at), "MM/DD/YYYY h:mm A") });
            });
            _this.page_by = response.orders.per_page;
            _this.submitting = false;
            _this.totalItems = response.orders.total;
        });
    };
    return AdminOrdersController;
}());
AdminOrdersController.$inject = [
    "OrdersModel",
    "FlashService",
    "PoliciesModel",
    "$q",
    "UserService",
    "UsersModel",
];
exports.default = AdminOrdersController;
